<template>
    <div role="group" class="form-group">
        <div class="checkbox-toggle float-right">
            <input v-on:input="onInput" type="checkbox" :id="getInputKey()" :checked="value" :disabled="disabled">
            <label :for="getInputKey()"></label>
        </div>
        <label :for="getInputKey()" class="col-form-label pt-0 d-inline">{{ label }}</label>
        <small class="form-text">{{ _.get(config, 'description') }}</small>
    </div>
</template>
<script>
import CustomSwitchComponent from './CustomSwitchComponent';

export default {
    data() {
        return {
            randomKey: Math.floor(Math.random() * 1000000),
        }
    },

    props: ['value', 'label', 'required', 'data', 'config', 'error'],

    components: {
        CustomSwitchComponent,
    },

    computed: {
        description() {
            return _.get(this.config, 'description', '');
        },

        disabled() {
            return _.get(this.config, 'readonly', false);
        },
    },

    methods: {
        onInput(e) {
            const value = e.target.checked;

            this.$emit('input', value);
            this.$emit('change', value);
        },

        getInputKey() {
            return `switch-${this.randomKey}`;
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/InputSwitchComponent.vue